// <s-quantity-tiers> (snippets/quantity-tiers.liquid): quantity tier cards
// ([data-tier] buttons with aria-pressed). Picking a card:
// - sets the product form's quantity input (#product-quantity) when present, and
// - dispatches "quantity-tier:select" { quantity, percent } on document so the
//   size grid (<s-size-matrix>) can show the goal.
// When the size grid's total changes ("size-matrix:total" { total }), the card
// of the highest tier reached is selected (or "1 unidade" below the first tier).
class SQuantityTiers extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    this.addEventListener('click', (event) => {
      const card = event.target.closest('[data-tier]');
      if (card) this.#pick(card);
    }, { signal });
    document.addEventListener('size-matrix:total', (event) => {
      this.#select(this.#cardForTotal(Number(event.detail?.total) || 0));
    }, { signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #cards() {
    return [...this.querySelectorAll('[data-tier]')];
  }

  #cardForTotal(total) {
    let best = this.#cards()[0];
    for (const card of this.#cards()) {
      if (Number(card.dataset.tier) <= Math.max(total, 1)) best = card;
    }
    return best;
  }

  #select(card) {
    if (!card) return;
    this.#cards().forEach((item) => item.setAttribute('aria-pressed', String(item === card)));
  }

  #pick(card) {
    this.#select(card);
    const quantity = Number(card.dataset.tier) || 1;
    const percent = Number(card.dataset.percent) || 0;
    const input = document.getElementById('product-quantity');
    if (input) {
      input.value = String(quantity);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    document.dispatchEvent(new CustomEvent('quantity-tier:select', { detail: { quantity, percent } }));
  }
}

if (!customElements.get('s-quantity-tiers')) customElements.define('s-quantity-tiers', SQuantityTiers);
